import { CheckIcon } from '@heroicons/react/24/solid'
import { useComponentTranslation } from '@tebuto/functions/translation.components'
import { EventLocation } from '@tebuto/widget/booking/types'
import { useContext, useMemo } from 'react'
import { BookingCalendarContext } from '../context'

export default function LocationFilters() {
    const { t } = useComponentTranslation()
    const { availableLocations, selectedLocations, setSelectedLocations } = useContext(BookingCalendarContext)

    const LocationMapping: Record<EventLocation, string> = useMemo(
        () => ({
            'not-fixed': t('notFixed'),
            onsite: t('onsite'),
            virtual: t('online')
        }),
        []
    )

    const toggleLocation = (location: EventLocation) => {
        if (selectedLocations.includes(location)) {
            // Don't allow deselecting all locations
            if (selectedLocations.length > 1) {
                setSelectedLocations(selectedLocations.filter((loc) => loc !== location))
            }
        } else {
            setSelectedLocations([...selectedLocations, location])
        }
    }

    const selectAll = () => {
        setSelectedLocations([...availableLocations])
    }

    const allSelected = selectedLocations.length === availableLocations.length

    // Don't show if no locations are available
    if (availableLocations.length === 0) {
        return null
    }

    return (
        <div className="space-y-3">
            <div className="flex items-center justify-between">
                <h4 className="font-medium text-sm widget-text-primary">{t('booking.bookingCalendar.locality')}</h4>
                {!allSelected && (
                    <button
                        type="button"
                        onClick={selectAll}
                        className="text-xs widget-text-secondary hover:widget-text-primary transition-colors"
                    >
                        {t('booking.bookingCalendar.selectAll')}
                    </button>
                )}
            </div>

            {/* Location List */}
            <div className="flex flex-col gap-2">
                {availableLocations.map((location) => {
                    const isSelected = selectedLocations.includes(location)
                    return (
                        <button
                            key={location}
                            type="button"
                            onClick={() => toggleLocation(location)}
                            className="flex items-center gap-3 py-1.5 transition-colors text-left"
                        >
                            <div
                                className="size-5 rounded border-2 flex items-center justify-center shrink-0 transition-colors"
                                style={
                                    isSelected
                                        ? {
                                              backgroundColor: 'var(--widget-primary-600)',
                                              borderColor: 'var(--widget-primary-600)'
                                          }
                                        : { borderColor: 'var(--widget-border)', backgroundColor: 'transparent' }
                                }
                            >
                                {isSelected && <CheckIcon className="size-3.5 text-white" />}
                            </div>
                            <span className="text-xs widget-text-primary">{LocationMapping[location]}</span>
                        </button>
                    )
                })}
            </div>
        </div>
    )
}
